


















import { Component, Emit, Model, Prop, Watch } from 'vue-property-decorator';
import { ViewpointApi, VIEWPOINT_API } from '@/api/ViewpointApi';
import Apps from '@/store/modules/Apps';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import Decisions from '@/store/modules/Decisions';
import { AppModel } from '@/api/model/AppModel';
import CardTitle from '@/components/common/CardTitle.vue';
import _ from 'lodash';
import { watch } from 'fs';

const appsModule = getModule(Apps);
const decisionsModule = getModule(Decisions);
@Component({
    components: { CardTitle },
})
export default class LaunchAppLoadingDialog extends Vue {


    @Prop({default: false, type: Boolean})
    dialog!: boolean

    @Prop()
    loading!: boolean

    @Prop({default: false, type: Boolean})
    copy!: boolean

    get cloneProgress() {
        return decisionsModule.cloneDecisionProgress
    }
}
